import { useCreate } from '@refinedev/core';
import { OAuthPlatform } from 'src/secret-menu/sharepoint/types';

type CreateRemoteDocsConnectionInput = {
  authCode: string;
  state: string;
  platform: OAuthPlatform;
};

export const useCreateRemoteDocsConnectionMutation = () => {
  const { mutateAsync, error, isLoading } = useCreate({
    resource: 'remote-docs-connections',
  });

  const createRemoteDocsConnection = async (
    input: CreateRemoteDocsConnectionInput,
  ): Promise<void> => {
    await mutateAsync({
      values: input,
    });
  };

  return {
    createRemoteDocsConnection,
    isLoading,
    error,
  };
};
